import { Component, OnInit } from '@angular/core';
import frenchi18n from '@assets/i18n/fr.json';
import { Bank } from '@modules/process/models/bank';
import { ProcessEventFactory } from '@shared/models/processEvents';
import { TrackerService } from '@shared/services/tracker.service';
import { ProcessEventService } from '@shared/services/process-event.service';
import { StoreService } from '@shared/services/store.service';
import { AccountsService } from '../select-accounts/services/accounts.service';
import { ScaService } from './services/sca.service';

@Component({
  selector: 'app-sca-waiting',
  templateUrl: './sca-waiting.component.html',
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: { class: 'max-w-full d-flex flex-col justify-center items-center' },
  styleUrls: ['./sca-waiting.component.scss'],
})
export class ScaWaitingComponent implements OnInit {
  userId!: string;
  userToken!: string;
  connectionId!: string;
  isTestBankConnector = false;

  constructor(
    private scaServices: ScaService,
    private storeService: StoreService,
    private accountsService: AccountsService,
    private processEventService: ProcessEventService,
    private tracker: TrackerService
  ) {}

  ngOnInit(): void {
    this.tracker.trackPage({ taggingPage: 'SCA_WAITING_SCREEN' });

    this.userId = this.storeService.getVariableOrThrow('USER_ID');
    this.userToken = this.storeService.getVariableOrThrow('OPEN_BANKING_USER_TOKEN');
    this.connectionId = this.storeService.getVariableOrThrow('SELECTED_CONNECTION_ID');

    this.scaServices
      .requestDecoupledResolution({
        userId: this.userId,
        userToken: this.userToken,
        connectionId: this.connectionId,
      })
      .subscribe({
        next: () => {
          this.scaServices
            .pollUntilDecoupledIsResolved({
              connectionId: this.connectionId,
              userId: this.userId,
              userToken: this.userToken,
            })
            .subscribe({
              next: () => {
                this.accountsService
                  .getAccounts({
                    connectionId: this.connectionId,
                    userId: this.userId,
                    userToken: this.userToken,
                  })
                  .subscribe({
                    next: (accounts) => {
                      this.processEventService.push(ProcessEventFactory.SpawnAccountsFoundEvent(accounts));
                    },
                    error: (error) => {
                      this.processEventService.push(
                        ProcessEventFactory.SpawnInternalErrorEvent({
                          errorOrigin: 'ScaWaitingComponent - GetAccounts - Error',
                          error,
                        })
                      );
                    },
                  });
              },
              error: (error) => {
                if (error == 'MAX_RETRIES_REACHED') {
                  this.processEventService.push(ProcessEventFactory.SpawnScaFailedEvent());
                } else {
                  this.processEventService.push(
                    ProcessEventFactory.SpawnInternalErrorEvent({
                      errorOrigin: 'ScaWaitingComponent - requestDecoupledResolution - next',
                      error,
                    })
                  );
                }
              },
            });
        },
        error: (error) => {
          this.processEventService.push(
            ProcessEventFactory.SpawnInternalErrorEvent({
              errorOrigin: 'ScaWaitingComponent - requestDecoupledResolution - error',
              error,
            })
          );
        },
      });
  }

  goBack() {
    this.tracker.trackClick({ taggingPage: 'SCA_WAITING_SCREEN', click: frenchi18n.common_return });

    this.processEventService.push(ProcessEventFactory.SpawnScaGoBackEvent());
  }

  get selectedBank(): Bank {
    return this.storeService.getVariableOrThrow('SELECTED_BANK');
  }

  set selectedBank(value: Bank) {
    this.storeService.setVariable('SELECTED_BANK', value);
  }
}
